import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import Login from 'pages/Login/Login';
import createTheme from './styles/theme';

function App() {
  return (
    <ThemeProvider theme={createTheme()}>
      <CssBaseline />
      <Login />
    </ThemeProvider>
  );
}

export default App;
